module.exports = __webpack_public_path__ + "static/img/news4.82ca212.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/news4.jpg
// module id = bBVI
// module chunks = 1